
import { createAction, props } from '@ngrx/store';
import { ScheduleSummary } from '../../../api/models/schedule-summary.model';
import { Update } from '@ngrx/entity';

export const getSceneScheduleSummaryAction = createAction(
    '[SceneScheduleSummary] Get Scene Schedule Summary for Location via service',
    props<{ locationId: number }>()
);

export const setSceneScheduleSummaryAction = createAction(
    '[SceneScheduleSummary] Set Scene Schedule Summary for Location via service',
    props<{ sceneScheduleSummaryList: ScheduleSummary[] }>()
);

export const addSceneScheduleSummarySuccess = createAction(
    '[SceneScheduleSummary] Add Scene Schedule Summary successful for Location via service',
    props<{ sceneScheduleSummary: ScheduleSummary }>()
);

export const updateSceneScheduleSummarySuccess = createAction(
    '[SceneScheduleSummary] Update Scene Schedule Summary successful for Location via service',
    props<{ update: Update<ScheduleSummary> }>()
);

export const deleteSceneScheduleSummarySuccess = createAction(
    '[SceneScheduleSummary] Delete Scene Schedule Summary successful for Location via service',
    props<{ sceneId: number }>()
);

export const clear = createAction(
    '[SceneScheduleSummary] Clear all scene schedules'
);

export const sceneScheduleSummaryActionTypes = {
    getSceneScheduleSummaryAction,
    setSceneScheduleSummaryAction,
    addSceneScheduleSummarySuccess,
    updateSceneScheduleSummarySuccess,
    deleteSceneScheduleSummarySuccess,
    clear
}
